
import { Inject, Injectable } from '@angular/core';

import { SuzUpdateCredentialsCommand, SuzUpdateCredentialsCommandHandlerBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';

@CommandHandlerFor(SuzUpdateCredentialsCommand)
@Injectable({ providedIn: 'root'})
export class SuzUpdateCredentialsCommandHandler {
    private commandHandler: SuzUpdateCredentialsCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new SuzUpdateCredentialsCommandHandlerBase(http);
    }

    public async handleAsync(query: SuzUpdateCredentialsCommand): Promise<any> {
        return await this.commandHandler.handleAsync(query);
    }
}
